import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { BRAND, IMAGES } from "../../data";

const links = [
  { label: "Services", href: "#services" },
  { label: "Notre exigence", href: "#manifeste" },
  { label: "Flotte", href: "#flotte" },
  { label: "Zone", href: "#zone" },
  { label: "Avis", href: "#avis" },
];

export const Navbar = ({ onReserve }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#060B14]/80 backdrop-blur-xl border-b border-white/5" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-6 lg:px-12 h-20 flex items-center justify-between">
        <button data-testid="brand-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3 group">
          <span className="font-serif text-xl tracking-[0.1em] text-champagne border border-champagne/40 rounded-full w-11 h-11 flex items-center justify-center group-hover:bg-champagne group-hover:text-[#060B14] transition-colors duration-300">DP</span>
          <span className="hidden sm:block font-serif text-lg tracking-[0.25em] text-[#F7F5F0]">{BRAND.name}</span>
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button key={l.href} data-testid={`nav-${l.href.slice(1)}`} onClick={() => go(l.href)} className="text-sm text-[#94A3B8] hover:text-[#F7F5F0] transition-colors tracking-wide">
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button data-testid="nav-reserve-btn" onClick={onReserve} className="hidden sm:flex items-center gap-2 rounded-full bg-champagne text-[#060B14] px-6 py-2.5 text-sm font-semibold hover:opacity-90 transition-opacity">
            <MessageCircle size={16} /> Réserver
          </button>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen((v) => !v)} className="lg:hidden text-[#F7F5F0]">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      {open && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="lg:hidden bg-[#060B14]/95 backdrop-blur-xl border-t border-white/5 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button key={l.href} onClick={() => go(l.href)} className="text-left text-[#94A3B8] hover:text-[#F7F5F0] text-lg">{l.label}</button>
          ))}
          <button data-testid="mobile-reserve-btn" onClick={() => { setOpen(false); onReserve(); }} className="rounded-full bg-champagne text-[#060B14] px-6 py-3 font-semibold">Réserver</button>
        </motion.div>
      )}
    </motion.header>
  );
};
